import React, { useState, useEffect } from 'react';
import apiUrl from '../../Apiurl';
import { useAuth0 } from '@auth0/auth0-react';
import ListaProblemi from './AreaProblemiPS/ListaProblemi';
import SchedaProdotto from '../../SchedaProdotto';


function DBperAreaProblemiPS({product, setProductFunction, utente, setIDPSdiverso}) {


     const { user, getAccessTokenSilently } = useAuth0();
    const [token, setToken] = useState(""); 
    const [listaProblemi, setlistaProblemi] = useState([]);
    const [anteprimaProdotto, setAnteprimaProdotto] = useState("no data");

    useEffect(() => {
        if (!token) {
            console.warn("sto aspettando un token")
            return;
        }
        fetch(apiUrl + "/prodotti/get/problemiArticoliPS/", {headers: {Authorization: "Bearer "+token}}) 
          .then(resp => resp.json())
          .then(data => setlistaProblemi(data)) 
      }, [ token ]);


     useEffect(() => {
        const getUserMetadata = async () => {
     
          try {
            const accessToken = await getAccessTokenSilently();
            setToken(accessToken);
          } catch (e) {
            console.log(e.message);
          }
        };
     
        getUserMetadata();


      }, [getAccessTokenSilently, user?.sub]);



    return (
        <div class="center">
            <div class="cf contentSubSubHeader flex">
                <div class="fl-ns w-100 w-70-ns pr3 pl4 sfondoBiancoTema">
                    <ListaProblemi
                        setProductFunction={setProductFunction}
                        setAnteprimaProdotto={setAnteprimaProdotto}
                        listaProblemi={listaProblemi}
                        utente={utente}
                        setIDPSdiverso={setIDPSdiverso}
                        /* setlistaProblemi={setlistaProblemi} */
                    />
                </div>
                <div className='w-100 w-30-ns sfondoBiancoTema'>
                    {anteprimaProdotto !== "no data" && <SchedaProdotto className="" prodotto={anteprimaProdotto} lang="it" html={false} />}
                </div>
            </div>
        </div>

    )
}


export default DBperAreaProblemiPS;
